module.exports = __webpack_public_path__ + "static/img/200309.1720be90.png";